<template>
          <ais-state-results>
          <template #default="{ results: { query, hits } }">
            <div
              v-show="hits.length === 0 && query.length > 0"
              class="parentFrame"
            >
            <div class="frame-wrapper">
      <div class="frame-group">
        <div class="frame-container">
          <div class="card-declined-2-final-1-wrapper">
            <img
              class="card-declined-2-final-1"
              loading="lazy"
              alt=""
              src="https://prod-site-cdn.paykoko.com/bnpl-site-cms-dev/Koko-search/Card%20Declined%20(2)_FINAL%201.png"
            />
          </div>
          <h3 class="sorry-no-matching">
            Sorry, no matching result was found for your query.
          </h3>
        </div>
        <div class="please-try-another-query-wrapper">
          <div class="please-try-another">Please try another query.</div>
        </div>
      </div>
    </div>
            </div>
          </template>
        </ais-state-results>
</template>

<script>
 import {AisStateResults } from 'vue-instantsearch/vue3/es';
export default {
  components: {
    AisStateResults
  }
}
</script>

<style>
.card-declined-2-final-1 {
    height: 170px;
    width: 195px;
    position: relative;
    object-fit: cover;
  }
  .card-declined-2-final-1-wrapper {
    align-self: stretch;
    flex: 1;
    /* display: flex; */
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 47px;
  }
  .sorry-no-matching {
    margin: 0;
    align-self: stretch;
    position: relative;
    font-size: inherit;
    font-weight: 600;
    font-family: inherit;
  }
  .frame-container {
    align-self: stretch;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
  .please-try-another {
    position: relative;
  }
  .please-try-another-query-wrapper {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    padding: 0px 20px;
    text-align: left;
    font-size: 12px;
    color: #000;
  }
  .frame-group {
    align-self: stretch;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 24px;
  }
  .frame-wrapper {
    align-self: stretch;
    height: 237px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 0px 49.09999999999991px 0px 56px;
    box-sizing: border-box;
    text-align: center;
    font-size: 18px;
    color: #021fa3;
    margin-top: 81px;
  }
  .frame-parent {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 81px;
    max-width: 100%;
    text-align: left;
    font-size: 12px;
    color: #000;
    font-family: Raleway;
  }

  @media screen and (max-width: 404px) {
    .frame-wrapper {
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
    }

    .frame-parent {
      gap: 40px 81px;
    }
  }
  @media screen and (max-width: 289px) {
    .card-declined-2-final-1-wrapper {
      padding-left: 20px;
      padding-right: 20px;
      box-sizing: border-box;
    }
  }

</style>